/* ============================================================
   EMMY BEAUTY — theme.js
   Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  var trapStack = [];

  function trapFocus(container) {
    var focusable = container.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    trapStack.push({ container: container, handler: handler, returnFocus: document.activeElement });
    (container.querySelector('[autofocus]') || first).focus();
  }

  function releaseFocus(container) {
    var entry = trapStack.pop();
    if (entry && entry.container === container) {
      container.removeEventListener('keydown', entry.handler);
      if (entry.returnFocus && entry.returnFocus.focus) entry.returnFocus.focus();
    }
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal, .reveal-image');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Sticky / transparent header ---------- */
  function initHeader() {
    var wrapper = document.querySelector('[data-header-wrapper]');
    if (!wrapper) return;
    var threshold = 60;
    var spacer = null;
    function onScroll() {
      var stuck = window.scrollY > threshold;
      if (stuck && !wrapper.classList.contains('is-stuck')) {
        if (!wrapper.classList.contains('header-wrapper--transparent')) {
          spacer = spacer || document.createElement('div');
          spacer.style.height = wrapper.offsetHeight + 'px';
          wrapper.parentNode.insertBefore(spacer, wrapper);
        }
        wrapper.classList.add('is-stuck');
      } else if (!stuck && wrapper.classList.contains('is-stuck')) {
        wrapper.classList.remove('is-stuck');
        if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Desktop dropdowns / mega menu
    document.querySelectorAll('[data-menu-item]').forEach(function (item) {
      var trigger = item.querySelector('[aria-expanded]');
      if (!trigger) return;
      function open() { item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
      function close() { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        item.classList.contains('is-open') ? close() : open();
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  /* ---------- Mobile menu drawer ---------- */
  function initMenuDrawer() {
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer) return;
    var openBtn = document.querySelector('[data-menu-open]');
    var closeEls = drawer.querySelectorAll('[data-menu-close]');
    function open() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      openBtn && openBtn.setAttribute('aria-expanded', 'true');
      trapFocus(drawer.querySelector('.menu-drawer__panel'));
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      openBtn && openBtn.setAttribute('aria-expanded', 'false');
      releaseFocus(drawer.querySelector('.menu-drawer__panel'));
    }
    openBtn && openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    drawer.querySelector('.menu-drawer__overlay').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    drawer.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        var openNow = sub.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', openNow ? 'true' : 'false');
      });
    });
  }

  /* ---------- Search modal ---------- */
  function initSearch() {
    var modal = document.getElementById('SearchModal');
    if (!modal) return;
    var openBtn = document.querySelector('[data-search-open]');
    function open() {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      trapFocus(modal);
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      releaseFocus(modal);
    }
    openBtn && openBtn.addEventListener('click', open);
    modal.querySelector('[data-search-close]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* ---------- Cart drawer + AJAX cart ---------- */
  var cartDrawer = {
    el: null,
    init: function () {
      this.el = document.getElementById('CartDrawer');
      if (!this.el) return;
      var self = this;
      document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });
      this.el.querySelector('[data-cart-drawer-close]').addEventListener('click', this.close.bind(this));
      this.el.querySelector('[data-cart-drawer-overlay]').addEventListener('click', this.close.bind(this));
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });
      this.bindLineEvents();
    },
    open: function () {
      if (!this.el) { window.location.href = window.theme.cartUrl; return; }
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      trapFocus(this.el.querySelector('.cart-drawer__panel'));
    },
    close: function () {
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
      releaseFocus(this.el.querySelector('.cart-drawer__panel'));
    },
    bindLineEvents: function () {
      var self = this;
      if (!this.el) return;
      this.el.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.changeLine(btn.dataset.line, 0);
        });
      });
      this.el.querySelectorAll('.cart-item .quantity__input').forEach(function (input) {
        input.addEventListener('change', function () {
          self.changeLine(input.dataset.line, parseInt(input.value, 10) || 1);
        });
      });
    },
    changeLine: function (line, quantity) {
      var self = this;
      fetch(window.theme.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { self.refresh(); });
    },
    refresh: function () {
      var self = this;
      // Re-fetch the document and swap drawer contents + header count.
      fetch(window.location.href, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('CartDrawer');
          if (fresh && self.el) {
            self.el.querySelector('[data-cart-drawer-items]').innerHTML = fresh.querySelector('[data-cart-drawer-items]').innerHTML;
            var freshFooter = fresh.querySelector('[data-cart-drawer-footer]');
            var footer = self.el.querySelector('[data-cart-drawer-footer]');
            footer.innerHTML = freshFooter.innerHTML;
            if (freshFooter.hasAttribute('hidden')) footer.setAttribute('hidden', ''); else footer.removeAttribute('hidden');
            var shipping = self.el.querySelector('[data-cart-drawer-shipping]');
            var freshShipping = fresh.querySelector('[data-cart-drawer-shipping]');
            if (shipping && freshShipping) shipping.innerHTML = freshShipping.innerHTML;
            var bubble = self.el.querySelector('[data-cart-count-bubble]');
            var freshBubble = fresh.querySelector('[data-cart-count-bubble]');
            if (bubble && freshBubble) bubble.textContent = freshBubble.textContent;
            self.bindLineEvents();
          }
          var freshCount = doc.querySelector('[data-header-cart-count]');
          var count = document.querySelector('[data-header-cart-count]');
          if (freshCount && count) count.outerHTML = freshCount.outerHTML;
        });
    }
  };

  /* ---------- <product-form> AJAX add to cart ---------- */
  var ProductForm = (function () {
    if (typeof HTMLElement === 'undefined') return null;
    function PF() { return Reflect.construct(HTMLElement, [], PF); }
    PF.prototype = Object.create(HTMLElement.prototype);
    PF.prototype.connectedCallback = function () {
      var form = this.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var button = form.querySelector('[type="submit"]');
        if (button) { button.classList.add('is-loading'); button.setAttribute('disabled', ''); }
        var formData = new FormData(form);
        fetch(window.theme.cartAddUrl + '.js', { method: 'POST', body: formData })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw d; });
            return r.json();
          })
          .then(function () {
            cartDrawer.refresh();
            setTimeout(function () { cartDrawer.open(); }, 250);
          })
          .catch(function (err) {
            if (err && err.description) alert(err.description);
          })
          .finally(function () {
            if (button) { button.classList.remove('is-loading'); button.removeAttribute('disabled'); }
          });
      });
    };
    return PF;
  })();
  if (ProductForm && !customElements.get('product-form')) customElements.define('product-form', ProductForm);

  /* ---------- <quantity-input> ---------- */
  var QuantityInput = (function () {
    function QI() { return Reflect.construct(HTMLElement, [], QI); }
    QI.prototype = Object.create(HTMLElement.prototype);
    QI.prototype.connectedCallback = function () {
      var input = this.querySelector('input');
      this.querySelector('[name="minus"]').addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value, 10) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      this.querySelector('[name="plus"]').addEventListener('click', function () {
        input.value = parseInt(input.value, 10) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };
    return QI;
  })();
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

  /* ---------- <cart-drawer> custom element shell ---------- */
  var CartDrawerEl = (function () {
    function CD() { return Reflect.construct(HTMLElement, [], CD); }
    CD.prototype = Object.create(HTMLElement.prototype);
    return CD;
  })();
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawerEl);

  /* ---------- Accordions (FAQ + product) ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-accordion-item]');
        var content = item.querySelector('[data-accordion-content]');
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ---------- Carousels ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('.carousel__track');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;
      function step() {
        var slide = track.querySelector('.carousel__slide');
        return slide ? slide.getBoundingClientRect().width + 20 : 300;
      }
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Before / after slider ---------- */
  function initBeforeAfter() {
    document.querySelectorAll('[data-before-after]').forEach(function (el) {
      var range = el.querySelector('input[type="range"]');
      var after = el.querySelector('.before-after__after');
      var handle = el.querySelector('.before-after__handle');
      function update(v) {
        after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
        handle.style.left = v + '%';
      }
      range.addEventListener('input', function () { update(range.value); });
      update(range.value);
    });
  }

  /* ---------- Hero entrance + background video ---------- */
  function initHero() {
    document.querySelectorAll('.hero').forEach(function (hero) {
      requestAnimationFrame(function () { hero.classList.add('is-loaded'); });
    });

    document.querySelectorAll('[data-hero-video-wrap]').forEach(function (wrap) {
      var desktop = wrap.querySelector('[data-hero-video="desktop"]');
      var mobile = wrap.querySelector('[data-hero-video="mobile"]');
      if (desktop && mobile) desktop.classList.add('has-mobile-alt');
      var mq = window.matchMedia('(max-width: 749px)');
      var all = [desktop, mobile].filter(Boolean);

      function activeVideo() {
        if (mq.matches && mobile) return mobile;
        return desktop || mobile;
      }

      function reveal(vid) { vid.classList.add('is-playing'); }

      // Bind reveal + error handling once, BEFORE attempting playback,
      // so a fast (cached) autoplay can't fire 'playing' before we listen.
      all.forEach(function (vid) {
        if (vid.dataset.bound) return;
        vid.dataset.bound = '1';
        vid.muted = true;                 // property form is what iOS honours
        vid.setAttribute('muted', '');
        vid.playsInline = true;
        ['playing', 'loadeddata', 'canplay', 'timeupdate'].forEach(function (ev) {
          vid.addEventListener(ev, function () { if (!vid.paused) reveal(vid); });
        });
        vid.addEventListener('error', function () { vid.classList.remove('is-playing'); });
        // Already playing/ready before listeners attached? Reveal now.
        if (vid.readyState >= 2 && !vid.paused) reveal(vid);
      });

      function attempt(vid) {
        if (!vid) return;
        vid.muted = true;
        var p = vid.play();
        if (p && p.catch) p.catch(function () { /* blocked — fallback image stays */ });
      }

      function playActive() {
        var vid = activeVideo();
        if (!vid) return;
        // Stop & unload the inactive variant to save data and avoid double playback.
        all.forEach(function (v) {
          if (v !== vid) { v.removeAttribute('autoplay'); try { v.pause(); } catch (e) {} }
        });
        vid.preload = 'auto';
        attempt(vid);
        // If still paused on next frame, reveal already-buffered frame anyway.
        requestAnimationFrame(function () { if (vid.readyState >= 2 && !vid.paused) reveal(vid); });
      }

      playActive();
      if (mq.addEventListener) mq.addEventListener('change', playActive);
      else if (mq.addListener) mq.addListener(playActive);

      // Fallback: if autoplay was blocked, start on the first user interaction.
      function kickstart() {
        var vid = activeVideo();
        if (vid && vid.paused) attempt(vid);
        if (vid && !vid.paused) {
          ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (ev) {
            window.removeEventListener(ev, kickstart);
          });
        }
      }
      ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (ev) {
        window.addEventListener(ev, kickstart, { passive: true });
      });

      // Pause when off-screen to save battery / data, resume when back.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var vid = activeVideo();
            if (!vid) return;
            if (entry.isIntersecting) { attempt(vid); }
            else { try { vid.pause(); } catch (e) {} }
          });
        }, { threshold: 0.1 }).observe(wrap);
      }
    });
  }

  /* ---------- Product gallery, zoom, variants, sticky ATC ---------- */
  function initProductPage() {
    var product = document.querySelector('[data-product]');
    if (!product) return;

    // Thumbnails
    var mainImage = product.querySelector('[data-main-image]');
    product.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImage) {
          mainImage.src = thumb.dataset.src;
          mainImage.srcset = thumb.dataset.srcset || '';
          mainImage.alt = thumb.dataset.alt || '';
        }
        product.querySelectorAll('[data-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    // Zoom
    var mediaWrap = product.querySelector('[data-zoom]');
    if (mediaWrap) {
      mediaWrap.addEventListener('click', function (e) {
        var rect = mediaWrap.getBoundingClientRect();
        mediaWrap.style.setProperty('--zoom-x', ((e.clientX - rect.left) / rect.width * 100) + '%');
        mediaWrap.style.setProperty('--zoom-y', ((e.clientY - rect.top) / rect.height * 100) + '%');
        mediaWrap.classList.toggle('is-zoomed');
      });
    }

    // Variant selection
    var variantData = product.querySelector('[data-variant-json]');
    if (variantData) {
      var variants = JSON.parse(variantData.textContent);
      var picker = product.querySelector('[data-variant-picker]');
      var idInput = product.querySelector('input[name="id"]');
      var priceEl = product.querySelector('[data-product-price]');
      var atcButton = product.querySelector('[data-atc-button]');
      var stickyPrice = document.querySelector('[data-sticky-price]');

      function currentOptions() {
        var opts = [];
        product.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          opts[parseInt(fieldset.dataset.optionIndex, 10)] = checked ? checked.value : null;
        });
        return opts;
      }

      function onVariantChange() {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (match) {
          idInput.value = match.id;
          if (priceEl) priceEl.textContent = formatMoney(match.price);
          if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);
          if (atcButton) {
            if (match.available) {
              atcButton.removeAttribute('disabled');
              atcButton.querySelector('span').textContent = window.theme.strings.addToCart;
            } else {
              atcButton.setAttribute('disabled', '');
              atcButton.querySelector('span').textContent = window.theme.strings.soldOut;
            }
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        } else if (atcButton) {
          atcButton.setAttribute('disabled', '');
          atcButton.querySelector('span').textContent = window.theme.strings.unavailable;
        }
      }
      picker && picker.addEventListener('change', onVariantChange);
    }

    // Sticky add-to-cart
    var sticky = document.querySelector('[data-sticky-atc]');
    var buyBox = product.querySelector('[data-buy-buttons]');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(buyBox);
      var stickyBtn = sticky.querySelector('[data-sticky-add]');
      stickyBtn && stickyBtn.addEventListener('click', function () {
        var form = product.querySelector('form[data-type="add-to-cart-form"]');
        form && form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    // Frequently bought together
    var fbt = document.querySelector('[data-fbt]');
    if (fbt) {
      var totalEl = fbt.querySelector('[data-fbt-total]');
      function updateTotal() {
        var total = 0;
        fbt.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
          total += parseInt(cb.dataset.price, 10);
        });
        if (totalEl) totalEl.textContent = formatMoney(total);
      }
      fbt.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', updateTotal);
      });
      updateTotal();
      var addBtn = fbt.querySelector('[data-fbt-add]');
      addBtn && addBtn.addEventListener('click', function () {
        var items = [];
        fbt.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
          items.push({ id: parseInt(cb.value, 10), quantity: 1 });
        });
        if (!items.length) return;
        addBtn.classList.add('is-loading');
        fetch(window.theme.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () { cartDrawer.refresh(); cartDrawer.open(); })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      });
    }
  }

  /* ---------- Collection: load more ---------- */
  function initLoadMore() {
    var btn = document.querySelector('[data-load-more]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var nextUrl = btn.dataset.nextUrl;
      if (!nextUrl) return;
      btn.classList.add('is-loading');
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-product-grid]');
          var grid = document.querySelector('[data-product-grid]');
          if (newGrid && grid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (child) {
              grid.appendChild(child);
              child.classList.add('is-visible');
            });
          }
          var newBtn = doc.querySelector('[data-load-more]');
          if (newBtn && newBtn.dataset.nextUrl) {
            btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          } else {
            btn.parentNode.removeChild(btn);
          }
        })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- Facets auto-submit ---------- */
  function initFacets() {
    var form = document.querySelector('[data-facets-form]');
    if (!form) return;
    form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () { form.submit(); });
    });
    var sortSelect = form.querySelector('[data-sort-select]');
    sortSelect && sortSelect.addEventListener('change', function () { form.submit(); });
  }

  /* ---------- Video facade ---------- */
  function initVideo() {
    document.querySelectorAll('[data-video-facade]').forEach(function (wrap) {
      var play = wrap.querySelector('.video-section__play');
      play && play.addEventListener('click', function () {
        var src = wrap.dataset.videoUrl;
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.setAttribute('allowfullscreen', '');
        iframe.title = wrap.dataset.videoTitle || 'Video';
        wrap.innerHTML = '';
        wrap.appendChild(iframe);
      });
    });
  }

  /* ---------- Lightbox (social proof screenshots) ---------- */
  function initLightbox() {
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-lightbox-trigger]'));
    if (!triggers.length) return;

    var overlay = document.createElement('div');
    overlay.className = 'lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<button type="button" class="lightbox__close" aria-label="Fermer">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m6 6 12 12M18 6 6 18"/></svg></button>' +
      '<button type="button" class="lightbox__nav lightbox__nav--prev" aria-label="Précédent">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20 12H4m6 6-6-6 6-6"/></svg></button>' +
      '<img class="lightbox__img" alt="">' +
      '<button type="button" class="lightbox__nav lightbox__nav--next" aria-label="Suivant">' +
        '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 12h16m-6-6 6 6-6 6"/></svg></button>';
    document.body.appendChild(overlay);

    var img = overlay.querySelector('.lightbox__img');
    var current = 0;

    function show(i) {
      current = (i + triggers.length) % triggers.length;
      var t = triggers[current];
      img.src = t.dataset.lightboxSrc;
      img.alt = t.dataset.lightboxAlt || '';
    }
    function open(i) {
      show(i);
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      img.src = '';
    }

    triggers.forEach(function (t, i) {
      t.addEventListener('click', function () { open(i); });
    });
    overlay.querySelector('.lightbox__close').addEventListener('click', close);
    overlay.querySelector('.lightbox__nav--prev').addEventListener('click', function () { show(current - 1); });
    overlay.querySelector('.lightbox__nav--next').addEventListener('click', function () { show(current + 1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });

    // Touch swipe on the image
    var startX = 0;
    overlay.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) show(dx < 0 ? current + 1 : current - 1);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initHeader();
    initMenuDrawer();
    initSearch();
    cartDrawer.init();
    initAccordions();
    initCarousels();
    initBeforeAfter();
    initHero();
    initProductPage();
    initLoadMore();
    initFacets();
    initVideo();
    initLightbox();
  });
})();
